const isIsoDateString = (value) =>
  typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value);

export const compareValues = (a, b) => {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;

  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  }

  if (isIsoDateString(a) && isIsoDateString(b)) {
    return new Date(a) - new Date(b);
  }

  return String(a).localeCompare(String(b));
};

export const sortRows = (rows, sortConfig) => {
  if (!rows || !sortConfig?.key) return rows;
  const sorted = [...rows].sort((rowA, rowB) => {
    const result = compareValues(rowA[sortConfig.key], rowB[sortConfig.key]);
    return sortConfig.direction === "desc" ? -result : result;
  });
  return sorted;
};

export const nextSortConfig = (prevConfig, key) =>
  prevConfig.key === key
    ? { key, direction: prevConfig.direction === "asc" ? "desc" : "asc" }
    : { key, direction: "asc" };
